import { createAction } from '@reduxjs/toolkit'

export const saveTokenId = createAction<string>('@@smsCode/SAVE_TOKEN_ID')
export const disableSendingCode = createAction<string | undefined>('@@smsCode/DISABLE_SENDING_CODE')
export const allowSendingCode = createAction<string | undefined>('@@smsCode/ALLOW_SENDING_CODE')
